import { Options, Vue } from "vue-property-decorator";

@Options({})
export class TelephoneHelperMixin extends Vue {
  protected telephoneValid: undefined | boolean = false;
  protected telephoneValid2: undefined | boolean = false;

  protected telephoneIsValid(valid: boolean | undefined) {
    this.telephoneValid = valid;
  }
  protected telephoneIsValid2(valid: boolean | undefined) {
    this.telephoneValid2 = valid;
  }
}
